import { ApiClient } from '../client/ApiClient';
import { ApiResponse } from '../types';
import { InitiateOtpResponse } from './types';

export class OrderServicePublicClient extends ApiClient {
  private readonly _orderServicePublicBaseUrl: string;
  private readonly _orderServicePublicApiKey: string;
  private readonly _countryCode: string;

  constructor({
    orderServicePublicUrl,
    orderServicePublicApiKey,
    countryCode,
  }: {
    orderServicePublicUrl: string;
    orderServicePublicApiKey: string;
    countryCode: string;
  }) {
    super();
    this._orderServicePublicBaseUrl = orderServicePublicUrl;
    this._orderServicePublicApiKey = orderServicePublicApiKey;
    this._countryCode = countryCode;
  }

  protected get requestHeaders() {
    return {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': this._orderServicePublicApiKey,
      'x-jbg-country': this._countryCode,
      'x-jbg-company': 'JBH',
    };
  }

  initiateOtp = async ({ orderId }: { orderId: string }): Promise<ApiResponse<InitiateOtpResponse>> => {
    const { data, statusCode, error } = await this._fetch<InitiateOtpResponse>({
      path: `${this._orderServicePublicBaseUrl}/InitiateRiskifiedOTP`,
      method: 'POST',
      body: {
        orderId,
      },
    });

    const responseError = data?.error || error;
    if (responseError) {
      console.log('Error initiating Riskified OTP', { responseError, statusCode });
      return { error, statusCode };
    }

    return { data, statusCode };
  };

  verifyOtp = async ({ orderId, challengeToken }: { orderId: string; challengeToken: string }) => {
    const { statusCode, error } = await this._fetch({
      path: `${this._orderServicePublicBaseUrl}/VerifyRiskifiedOTP`,
      method: 'POST',
      body: {
        orderId,
        challengeToken,
      },
    });

    const isSuccess = !error && statusCode === 202;
    return { isSuccess, error };
  };
}
